import * as React from "react";
import { HelmetProvider } from "react-helmet-async";

export const helmetContext = {};

export const HelmetWrapperProvider = ({ children }) => (
  <HelmetProvider context={helmetContext}>{children}</HelmetProvider>
);
